import { useEffect, useRef, useState } from 'react';
import { Else, If, Then, When } from 'react-if';
import { useIsomorphicLayoutEffect } from '@toss/react';
import cns from 'classnames';
import { scroll } from 'motion';
import { useTranslation } from 'next-i18next';
import { Button } from '@zep/ui';
import S from './UploadBottomButtonsLayer.module.scss';
const UploadBottomButtonsLayer = (props: AssetUploadBottomProps) => {
  const {
    inputStep,
    editHashId,
    onPrev,
    onNext,
    onSubmit
  } = props;
  const bottomRef = useRef(null);
  const [isSticky, setIsSticky] = useState(false);
  const {
    t
  } = useTranslation(['store']);
  const handleSticky = (containerHeight: number) => {
    if (!bottomRef.current) return;
    const {
      bottom
    } = (bottomRef.current as HTMLElement).getBoundingClientRect();
    if (bottom >= containerHeight) setIsSticky(true);else setIsSticky(false);
  };

  // MEMO: 콘텐츠의 높이나 길이가 변경될 때 그림자 효과 ON/OFF
  useIsomorphicLayoutEffect(() => {
    const observer = new ResizeObserver(() => handleSticky(window.innerHeight));
    observer.observe(document.body);
    return () => observer.disconnect();
  }, []);
  useEffect(() => {
    const stop = scroll(({
      y
    }) => {
      handleSticky(y.containerLength);
    });
    return () => stop();
  }, []);
  return <div ref={bottomRef} className={cns(S.container, isSticky && S.sticky)} data-sentry-component="UploadBottomButtonsLayer" data-sentry-source-file="UploadBottomButtonsLayer.tsx">
      <div className={S.full_width}>
        <div className={S.inner}>
          <div className={S.button_group}>
            <When condition={inputStep === 'detail'} data-sentry-element="When" data-sentry-source-file="UploadBottomButtonsLayer.tsx">
              <Button variant="sub" className="w-[140px]" onClick={onPrev} data-sentry-element="Button" data-sentry-source-file="UploadBottomButtonsLayer.tsx">
                {t('store:store_bottom_bar_before')}
              </Button>
            </When>
          </div>
          <div className={S.button_group}>
            <If condition={inputStep === 'common'} data-sentry-element="If" data-sentry-source-file="UploadBottomButtonsLayer.tsx">
              <Then data-sentry-element="Then" data-sentry-source-file="UploadBottomButtonsLayer.tsx">
                <Button className="w-[140px]" onClick={onNext} data-sentry-element="Button" data-sentry-source-file="UploadBottomButtonsLayer.tsx">
                  {t('store:store_bottom_bar_next')}
                </Button>
              </Then>
              <Else data-sentry-element="Else" data-sentry-source-file="UploadBottomButtonsLayer.tsx">
                <Button className="w-[140px]" onClick={onSubmit} data-sentry-element="Button" data-sentry-source-file="UploadBottomButtonsLayer.tsx">
                  {editHashId ? t('store:store_edit') : t('store:store_bottom_bar_register')}
                </Button>
              </Else>
            </If>
          </div>
        </div>
      </div>
    </div>;
};
export default UploadBottomButtonsLayer;
type AssetUploadBottomProps = {
  inputStep: string;
  editHashId: string;
  onPrev: () => void;
  onNext: () => void;
  onSubmit: () => void;
};